import axios from "axios";

const fetchResellers = (params, config) => {
  return axios.get("/api/v1/resellers", { params, ...config });
};

const getReseller = (id) => {
  return axios.get(`/api/v1/resellers/${id}`);
};

const createReseller = (reseller) => {
  return axios.post("/api/v1/resellers", reseller);
};

const updateReseller = (id, reseller) => {
  return axios.patch(`/api/v1/resellers/${id}`, reseller);
};

const deleteReseller = (id) => {
  return axios.delete(`/api/v1/resellers/${id}`);
};

const inviteResellerUser = (resellerId, resellerUser) => {
  return axios.post(`/api/v1/resellers/${resellerId}/invite`, resellerUser);
};

const fetchResellerUsers = (resellerId, params, config) => {
  return axios.get(`/api/v1/resellers/${resellerId}/users`, {
    params,
    ...config,
  });
};

const updateResellerUser = (resellerId, resellerUserId, resellerUser) => {
  return axios.patch(
    `/api/v1/resellers/${resellerId}/users/${resellerUserId}`,
    resellerUser,
  );
};

const deleteResellerUser = (resellerId, resellerUserId) => {
  return axios.delete(
    `/api/v1/resellers/${resellerId}/users/${resellerUserId}`,
  );
};

const fetchResellerCompanies = (resellerId, pagination, config) => {
  return axios.get(`/api/v1/resellers/${resellerId}/companies`, {
    params: { ...pagination },
    ...config,
  });
};

const exportToExcel = (resellerId) => {
  return axios({
    url: `/api/v1/resellers/${resellerId}/export_companies_to_excel`,
    method: "GET",
    responseType: "blob",
  });
};

const fetchResellerErrors = (resellerId, params, config) => {
  return axios.get(`/api/v1/resellers/${resellerId}/errors`, {
    params,
    ...config,
  });
};

const fetchResellerStatistics = (resellerId, params, config) => {
  return axios.get(`/api/v1/resellers/${resellerId}/statistics`, {
    params,
    ...config,
  });
};

const fetchResellerCompanyGroups = (resellerId, params, config) => {
  return axios.get(`/api/v1/resellers/${resellerId}/company_groups`, {
    params,
    ...config,
  });
};

const addResellerCompanyGroup = (resellerId, resellerCompanyGroup) => {
  return axios.post(
    `/api/v1/resellers/${resellerId}/add_company_group`,
    resellerCompanyGroup,
  );
};

const updateResellerCompanyGroup = (
  resellerId,
  resellerCompanyGroupId,
  resellerCompanyGroup,
) => {
  return axios.patch(
    `/api/v1/resellers/${resellerId}/company_groups/${resellerCompanyGroupId}`,
    resellerCompanyGroup,
  );
};

const deleteResellerCompanyGroup = (resellerId, resellerUserId) => {
  return axios.delete(
    `/api/v1/resellers/${resellerId}/company_groups/${resellerUserId}`,
  );
};

const ApiResellers = {
  fetchResellers,
  getReseller,
  createReseller,
  updateReseller,
  deleteReseller,
  fetchResellerUsers,
  inviteResellerUser,
  updateResellerUser,
  deleteResellerUser,
  fetchResellerCompanies,
  fetchResellerErrors,
  fetchResellerStatistics,
  fetchResellerCompanyGroups,
  addResellerCompanyGroup,
  updateResellerCompanyGroup,
  deleteResellerCompanyGroup,
  exportToExcel,
};

export default ApiResellers;
